/*
  MacShack product page behaviour (sections/ms-main-product.liquid).
  Gallery, variant switching, coverage choice, add to bag (device + warranty in one call),
  payment options, trade-in and quote sheets, sticky buy bar, related products.
*/
(function () {
  if (customElements.get('ms-product')) return;

  function money(cents, prefix) {
    var n = Math.round(cents) / 100;
    var whole = Math.floor(n);
    var frac = Math.round((n - whole) * 100);
    var s = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (frac) s += '.' + (frac < 10 ? '0' : '') + frac;
    return (prefix || 'R ') + s;
  }
  var reduced = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  class MsProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.data = JSON.parse(this.querySelector('[data-ms-data]').textContent);
      } catch (e) {
        console.error('ms-product: bad data', e);
        return;
      }
      this.variant = this.data.variants.find(function (v) { return v.id === this.data.selected; }, this) || this.data.variants[0];
      this.coverage = 'std';
      this.$ = function (sel) { return this.querySelector(sel); };
      this.$$ = function (sel) { return Array.prototype.slice.call(this.querySelectorAll(sel)); };

      this.initGallery();
      this.initOptions();
      this.initCoverage();
      this.initBuy();
      this.initDisclosures();
      this.initSheets();
      this.initBar();
      this.initAddons();
      this.initRelated();
      this.render();
    }

    /* ---------- Gallery ---------- */
    initGallery() {
      var track = this.$('[data-track]');
      if (!track) return;
      this.track = track;
      this.slides = this.$$('[data-slide]');
      this.thumbs = this.$$('[data-thumb]');
      this.dots = this.$$('[data-dot]');
      this.chip = this.$('[data-chip]');
      this.countEl = this.$('[data-count]');
      this.prev = this.$('[data-prev]');
      this.next = this.$('[data-next]');
      var self = this;
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          self.setSlide(i, false);
        });
      }, { passive: true });
      this.thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.goTo(i); });
      });
      if (this.prev) this.prev.addEventListener('click', function () { self.goTo(self.index - 1); });
      if (this.next) this.next.addEventListener('click', function () { self.goTo(self.index + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
      });
      this.index = 0;
      this.setSlide(0, false);
    }

    goTo(i) {
      if (!this.track) return;
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
      this.setSlide(i, true);
    }

    setSlide(i, fromUser) {
      if (!this.slides || !this.slides.length) return;
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.index = i;
      var slide = this.slides[i];
      if (this.chip) this.chip.hidden = slide.getAttribute('data-unit') !== 'true';
      if (this.countEl) this.countEl.textContent = (i + 1) + ' of ' + this.slides.length;
      this.thumbs.forEach(function (t, k) {
        t.classList.toggle('is-current', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      this.dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.slides.length - 1;
      if (fromUser && this.thumbs[i]) {
        var strip = this.thumbs[i].parentElement;
        var t = this.thumbs[i];
        if (t.offsetLeft < strip.scrollLeft || t.offsetLeft + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: t.offsetLeft - 8, behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
    }

    /* ---------- Variants ---------- */
    initOptions() {
      var self = this;
      this.$$('[data-option] input').forEach(function (input) {
        input.addEventListener('change', function () {
          var chosen = self.$$('[data-option]').map(function (fs) {
            var c = fs.querySelector('input:checked');
            return c ? c.value : null;
          });
          var match = self.data.variants.find(function (v) {
            return v.options.every(function (o, k) { return o === chosen[k]; });
          });
          if (match) {
            self.variant = match;
            self.render();
            if (match.media_index !== null && match.media_index !== undefined) self.goTo(match.media_index);
            var url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            history.replaceState({}, '', url.toString());
          } else {
            self.variant = Object.assign({}, self.variant, { available: false, unavailable: true });
            self.render();
          }
        });
      });
    }

    tierFor(cents) {
      var r = cents / 100;
      return (this.data.tiers || []).find(function (t) { return r >= t.min && r <= t.max; }) || null;
    }

    /* ---------- Coverage ---------- */
    initCoverage() {
      var self = this;
      this.$$('input[name="ms-coverage"]').forEach(function (r) {
        r.addEventListener('change', function () {
          self.coverage = r.value;
          self.renderTotals();
        });
      });
    }

    /* ---------- Render ---------- */
    render() {
      var v = this.variant, d = this.data, p = d.moneyPrefix;
      this.$$('[data-price]').forEach(function (el) { el.textContent = money(v.price, p); });
      var was = this.$('[data-was]'), save = this.$('[data-save]');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (was) { was.hidden = false; was.querySelector('[data-was-amt]').textContent = money(v.compare_at_price, p); }
        if (save) { save.hidden = false; save.textContent = 'Save ' + money(v.compare_at_price - v.price, p); }
      } else {
        if (was) was.hidden = true;
        if (save) save.hidden = true;
      }
      var longest = this.longestPlan();
      var mo = this.$('[data-mo-amt]');
      if (mo && longest) mo.textContent = money(Math.round(v.price / longest.term), p) + (longest.term > 4 ? '/mo for ' + longest.term + ' months' : ' × ' + longest.term);
      this.$$('[data-plan-amt]').forEach(function (el) {
        var term = parseInt(el.getAttribute('data-term'), 10);
        el.textContent = money(Math.round(v.price / term), p) + (term > 4 ? '/mo' : '');
      });

      // Stock line (same rules as the Liquid in the section)
      var av = this.$('[data-avail]');
      if (av) {
        var text, cls = 'msp-avail', note = '';
        if (v.unavailable) { text = 'This combination isn’t available'; cls += ' msp-avail--out'; }
        else if (!v.available) { text = 'Sold out'; cls += ' msp-avail--out'; }
        else if (d.byo) { text = 'Built to order'; cls += ' msp-avail--special'; note = d.byoNote || ''; }
        else if (v.managed && v.qty <= 0) { text = 'Special order'; cls += ' msp-avail--special'; note = d.specialNote || ''; }
        else if (d.arriving) { text = 'Arriving soon'; cls += ' msp-avail--soon'; }
        else if (d.supplier) { text = 'In stock at our supplier'; cls += ' msp-avail--supplier'; note = d.supplierNote || ''; }
        else {
          text = 'In stock';
          if (d.showStockCount && v.managed && v.qty > 0) text += ' — ' + v.qty + ' available';
          if (d.isUsed && v.managed && v.qty === 1) note = d.showStockCount ? 'The exact unit in the photos.' : 'The unit in the photos is the one you get.';
          else if (d.isUsed && v.managed && v.qty > 1) note = 'Photos show a unit of this grade.';
        }
        av.className = cls;
        av.querySelector('[data-avail-text]').textContent = text;
        // "The one you'll get" intro: exact-unit wording only when there is one in stock
        var lede = document.querySelector('[data-pass-lede]');
        if (lede) lede.textContent = (v.managed && v.qty > 1) ? lede.getAttribute('data-many') : lede.getAttribute('data-one');
        var small = av.querySelector('[data-avail-note]');
        small.textContent = note;
        small.hidden = !note;
      }

      // Quantity: shown whenever more than one can be bought; capped at stock when overselling is off
      var qty = this.$('[data-qty]');
      if (qty) {
        qty.hidden = !v.available || !!v.unavailable || (v.managed && v.deny && v.qty <= 1);
        var qin = qty.querySelector('input');
        if (v.managed && v.deny && v.qty > 0) qin.max = v.qty; else qin.removeAttribute('max');
        this.clampQty();
      }

      // Warranty tier
      this.tier = this.tierFor(v.price);
      var ext = this.$('[data-ext]');
      if (ext) {
        ext.hidden = !this.tier;
        if (this.tier) this.$('[data-ext-price]').textContent = '+ ' + money(this.tier.price * 100, p);
        if (!this.tier && this.coverage === 'ext') {
          this.coverage = 'std';
          var std = this.$('input[name="ms-coverage"][value="std"]');
          if (std) std.checked = true;
        }
      }

      this.$$('[data-add]').forEach(function (b) { b.disabled = !v.available; });
      this.renderTotals();
    }

    plans() {
      var d = this.data;
      return (d.payments || []).filter(function (pl) { return !pl.usedOnly || d.isUsed; });
    }

    longestPlan() {
      return this.plans().slice().sort(function (a, b) { return b.term - a.term; })[0];
    }

    maxQty() {
      var v = this.variant;
      return v && v.managed && v.deny && v.qty > 0 ? v.qty : Infinity;
    }

    /* Keep the quantity between 1 and stock; say so when it's at the limit. */
    clampQty() {
      var box = this.$('[data-qty]');
      if (!box) return;
      var input = box.querySelector('input'), max = this.maxQty();
      var n = Math.max(1, parseInt(input.value, 10) || 1);
      if (n > max) n = max;
      input.value = n;
      box.querySelector('[data-minus]').disabled = n <= 1;
      box.querySelector('[data-plus]').disabled = n >= max;
      var hint = this.$('[data-qty-max]');
      if (hint) {
        var show = !box.hidden && max !== Infinity && n >= max && max > 1;
        hint.hidden = !show;
        hint.textContent = show ? 'Only ' + max + ' available.' : '';
      }
    }

    qty() {
      var box = this.$('[data-qty]');
      var q = box && box.querySelector('input');
      if (!q || box.hidden) return 1;
      return Math.max(1, parseInt(q.value, 10) || 1);
    }

    total() {
      var t = this.variant.price * this.qty();
      if (this.coverage === 'ext' && this.tier) t += this.tier.price * 100 * this.qty();
      return t;
    }

    renderTotals() {
      var v = this.variant, p = this.data.moneyPrefix;
      var withExt = this.coverage === 'ext' && this.tier;
      var many = this.qty() > 1;
      var label = !v.available ? (v.unavailable ? 'Unavailable' : 'Sold out') : (withExt || many ? 'Add to Bag · ' + money(this.total(), p) : 'Add to Bag');
      this.$$('[data-add-label]').forEach(function (el) { el.textContent = label; });
      var total = this.total();
      this.$$('[data-bar-price]').forEach(function (el) { el.textContent = money(withExt || many ? total : v.price, p); });
      var ep = this.$('[data-ext-price]');
      if (ep && this.tier) ep.textContent = '+ ' + money(this.tier.price * 100, p) + (many ? ' each' : '');
      var sub = this.$('[data-bar-sub]');
      if (sub) {
        var longest = this.longestPlan();
        sub.textContent = many ? this.qty() + ' × ' + money(v.price, p) + (withExt ? ' + warranty' : '') : withExt ? 'Includes 12-month warranty' : (longest ? 'or ' + money(Math.round(v.price / longest.term), p) + (longest.term > 4 ? '/mo' : ' × ' + longest.term) : '');
      }
      var wl = this.$('[data-warranty-line]');
      if (wl) wl.textContent = withExt ? '12-month MacShack warranty' : '90-day MacShack warranty';
    }

    /* ---------- Add to bag ---------- */
    initBuy() {
      var self = this;
      this.$$('[data-add]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.add(btn); });
      });
      var q = this.$('[data-qty]');
      if (q) {
        var input = q.querySelector('input');
        q.querySelector('[data-minus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) - 1; self.clampQty(); self.renderTotals(); });
        q.querySelector('[data-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; self.clampQty(); self.renderTotals(); });
        input.addEventListener('change', function () { self.clampQty(); self.renderTotals(); });
      }
    }

    add(btn) {
      var v = this.variant;
      if (!v.available || btn.classList.contains('is-loading')) return;
      var err = this.$('[data-error]');
      if (err) err.textContent = '';
      var items = [{ id: v.id, quantity: this.qty() }];
      if (this.coverage === 'ext' && this.tier) items.push({ id: this.tier.id, quantity: this.qty(), properties: { _for: String(v.id) } });
      var minicart = document.querySelector('mini-cart');
      var body = { items: items };
      if (minicart && minicart.getSectionsToRender) {
        body.sections = minicart.getSectionsToRender().map(function (s) { return s.section; });
        body.sections_url = window.location.pathname;
      }
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (err) err.textContent = res.description || res.message || 'Something went wrong. Please try again.';
            return;
          }
          if (window.themeSettings && window.themeSettings.redirectToCart) { window.location.href = '/cart'; return; }
          if (minicart && res.sections) {
            try { minicart.renderContents(res); minicart.open(btn); } catch (e) { window.location.href = '/cart'; return; }
          } else {
            window.location.href = '/cart';
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: res.items || [res], context: 'MainProductPage' } }));
        })
        .catch(function (e) {
          console.error(e);
          if (err) err.textContent = 'Something went wrong. Please try again.';
        })
        .finally(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
    }

    /* ---------- Disclosures ---------- */
    initDisclosures() {
      var self = this;
      this.$$('[data-toggle]').forEach(function (btn) {
        var target = self.querySelector('#' + CSS.escape(btn.getAttribute('aria-controls')));
        if (!target) return;
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          target.hidden = !open;
          var lbl = btn.querySelector('[data-toggle-label]');
          if (lbl) lbl.textContent = open ? (lbl.getAttribute('data-open') || 'Hide') : (lbl.getAttribute('data-closed') || 'Options ›');
        });
      });
      this.$$('[data-open-pay]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var btn = self.$('[data-pay-toggle]');
          if (!btn) return;
          if (btn.getAttribute('aria-expanded') !== 'true') btn.click();
          btn.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
          btn.focus({ preventScroll: true });
        });
      });
    }

    /* ---------- Sheets ---------- */
    initSheets() {
      var self = this;
      this.$$('[data-sheet-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dlg = document.getElementById(btn.getAttribute('data-sheet-open'));
          if (!dlg) return;
          var frame = dlg.querySelector('iframe[data-src]');
          if (frame && !frame.getAttribute('src')) frame.setAttribute('src', frame.getAttribute('data-src'));
          if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        });
      });
      this.$$('dialog.msp-sheet').forEach(function (dlg) {
        dlg.querySelectorAll('[data-sheet-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      });
      this.$$('[data-quote]').forEach(function (a) {
        a.addEventListener('click', function () {
          var msg = self.quoteMessage();
          if (a.getAttribute('data-quote') === 'whatsapp') {
            a.href = 'https://wa.me/' + self.data.whatsapp + '?text=' + encodeURIComponent(msg);
          } else {
            a.href = 'mailto:' + self.data.email + '?subject=' + encodeURIComponent('Quote request: ' + self.data.title) + '&body=' + encodeURIComponent(msg);
          }
        });
      });
    }

    quoteMessage() {
      var v = this.variant, d = this.data;
      var m = 'Quote Request\n\nProduct: ' + d.title + '\n';
      if (v.title && v.title !== 'Default Title') m += 'Variant: ' + v.title + '\n';
      m += 'Quantity: ' + this.qty() + '\n';
      m += 'Price: ' + money(v.price, d.moneyPrefix) + '\n';
      if (this.coverage === 'ext' && this.tier) m += 'Extended warranty (12 months): ' + money(this.tier.price * 100, d.moneyPrefix) + '\n';
      m += '\n' + d.url;
      return m;
    }

    /* ---------- Sticky bar ---------- */
    initBar() {
      var bar = this.$('[data-bar]');
      var anchor = this.$('[data-bar-anchor]');
      if (!bar || !anchor || !('IntersectionObserver' in window)) return;
      var shown = false;
      var focusables = Array.prototype.slice.call(bar.querySelectorAll('a, button'));
      focusables.forEach(function (el) { el.tabIndex = -1; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          if (show === shown) return;
          shown = show;
          bar.classList.toggle('is-shown', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('msp-bar-on', show);
          focusables.forEach(function (el) { el.tabIndex = show ? 0 : -1; });
        });
      }, { threshold: 0 });
      io.observe(anchor);
    }

    /* ---------- Add-ons (app blocks such as Selleasy) ---------- */
    initAddons() {
      var sec = this.$('[data-addons]');
      if (!sec) return;
      var box = sec.querySelector('.msp-addons');
      var has = function () { return box.textContent.trim().length > 0 && box.querySelector('img, a, button'); };
      var update = function () { sec.hidden = !has(); };
      update();
      if ('MutationObserver' in window) {
        new MutationObserver(update).observe(box, { childList: true, subtree: true });
      }
    }

    /* ---------- Related products ---------- */
    initRelated() {
      var box = document.querySelector('[data-ms-related]');
      if (!box || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        fetch(box.getAttribute('data-url'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var src = doc.querySelector('[data-ms-related]');
            if (src && src.querySelector('.ms-card')) {
              box.innerHTML = src.innerHTML;
              box.hidden = false;
            }
          })
          .catch(function (e) { console.error(e); });
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(box.parentElement || box);
    }
  }

  customElements.define('ms-product', MsProduct);
})();
